import { Stack, styled, Typography } from "@mui/material";
import PrimaryButton from "components/button/PrimaryButton";
import FlexBetween from "components/flexbox/FlexBetween";
import { TypographyGradient } from "components/Typography";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Section = styled("section")(({ theme }) => ({}));

export const Section8 = () => {
  const innerHeight = window.innerHeight;
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });

  return (
    <Section
      ref={ref}
      sx={{
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <StyledContainer spacing={{ xs: 5, md: 10 }} pt={{ xs: 2, md: 10 }}>
        <Stack spacing={2} alignItems="center">
          <motion.div
            initial={{
              transform: `translateX(-50vw) scaleY(0)`,
              opacity: 0,
            }}
            animate={{
              transform: `translateX(${isInView ? 0 : -50}vw) scaleY(${isInView ? 1 : 0
                })`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{
              type: "spring",
              stiffness: 700,
              damping: 30,
              delay: 0.2,
            }}
          >
            <TypographyGradient
              sx={{
                textTransform: "uppercase",
                fontWeight: 700,
                fontSize: { xs: 20, md: 32, xmd: 36 },
                textAlign: "center",
              }}
            >
              Infrastructure partners
            </TypographyGradient>
          </motion.div>
          <motion.div
            initial={{
              transform: `translateX(-50vw) scaleY(0)`,
              opacity: 0,
            }}
            animate={{
              transform: `translateX(${isInView ? 0 : -50}vw) scaleY(${isInView ? 1 : 0
                })`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{
              type: "spring",
              stiffness: 700,
              damping: 40,
              delay: 0.25,
            }}
          >
            <Typography
              textTransform={"uppercase"}
              sx={{
                fontWeight: { xs: 400, md: 700 }, textAlign: "center",
                fontSize: { xs: '0.8rem', md: '1.3rem' }
              }}
            >
              Thanks to these partners for supporting Flaex sustainably and
              safely
            </Typography>
          </motion.div>
        </Stack>
        <FlexBetween
          gap={4}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <motion.img
            initial={{ transform: "translateY(-50px)", opacity: 0 }}
            animate={{
              transform: `translateY(${isInView ? 0 : -50}px)`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{ delay: 0.5 }}
            src="static/logo/AAVE-1.svg"
            style={{ height: 25 }}
          />
          <motion.img
            initial={{ transform: "translateY(-50px)", opacity: 0 }}
            animate={{
              transform: `translateY(${isInView ? 0 : -50}px)`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{ delay: 0.6 }}
            src="static/logo/UNISWAP.svg"
            style={{ height: 40 }}
          />
          <motion.img
            initial={{ transform: "translateY(-50px)", opacity: 0 }}
            animate={{
              transform: `translateY(${isInView ? 0 : -50}px)`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{ delay: 0.7 }}
            src="static/logo/CHAINLINK.svg"
            style={{ height: 37 }}
          />
        </FlexBetween>
        <motion.div
          style={{
            textAlign: "center",
          }}
          initial={{
            transform: "translateY(-40px) scale(3)",
            filter: "blur(40px)",
            opacity: 0,
          }}
          animate={{
            transform: `translateY(-${isInView ? 0 : 40}px) scale(${isInView ? 1 : 3
              })`,
            opacity: isInView ? 1 : 0,
            filter: `blur(${isInView ? 0 : 40}px)`,
          }}
          transition={{ delay: 1 }}
        >
          <Typography
            fontSize={{ xs: 20, md: 32, xmd: 36 }}
            mb={2}
            fontWeight={700}
            textTransform={"uppercase"}
          >
            Need more info?
          </Typography>
          <PrimaryButton
            sx={{
              background: "linear-gradient(90deg,#AA3AF6,#FDA9E5)",
              color: "#000",
              fontWeight: 700,
            }}
          >
            VIEW THE DOC
          </PrimaryButton>
        </motion.div>
      </StyledContainer>
    </Section>
  );
};

const StyledContainer = styled(Stack)(({ theme }) => ({
  height: "100vh",
  alignItems: "center",
  justifyContent: "center",
}));
